// extracted by mini-css-extract-plugin
export default {"classicToolbar":"ClassicToolbar_classicToolbar__grpPV","popover":"ClassicToolbar_popover__kuxwe"};